import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_BRANDS_INIT_ACTION,
  FETCH_BRANDS_SUCCESS_ACTION,
  FETCH_BRANDS_FAIL_ACTION,
  ADD_BRAND_INIT_ACTION,
  ADD_BRAND_SUCCESS_ACTION,
  ADD_BRAND_FAIL_ACTION,
  EDIT_BRAND_INIT_ACTION,
  EDIT_BRAND_SUCCESS_ACTION,
  EDIT_BRAND_FAIL_ACTION,
  DELETE_BRAND_INIT_ACTION,
  DELETE_BRAND_SUCCESS_ACTION,
  DELETE_BRAND_FAIL_ACTION,
  FETCH_ITEMBRANDINACTIVE_INIT_ACTION,
  FETCH_ITEMBRANDINACTIVE_SUCCESS_ACTION,
 
  FETCH_ITEMBRANDINACTIVE_FAIL_ACTION
} from "./action";
//import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//var btoa = require("Base64").btoa;
//var history = createBrowserHistory();

function* fetchBrands(value) {
  let pageno = value.value === undefined ? 1 : value.value;

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/brand?limit=10&page=` + pageno, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_BRANDS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_BRANDS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* AddBrand(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      name: value.value.brandName,
      disc: value.value.brandDescp,
      isActive: value.value.isActive
    };

    const res = yield fetch(`${appConfig.ip}/brand`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();

      yield put({ type: FETCH_BRANDS_INIT_ACTION });
      yield put({
        type: ADD_BRAND_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Brand added successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_BRAND_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* EditBrand(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      name: value.value.brandName,
      disc: value.value.brandDescp
    };

    const res = yield fetch(`${appConfig.ip}/brand/` + value.value.id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();
      yield put({ type: FETCH_BRANDS_INIT_ACTION });
      yield put({
        type: EDIT_BRAND_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Brand updated successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: EDIT_BRAND_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* DeleteItem(value) {
  let id = value.value;
  // let data = {
  //   isActive: false,
  // };
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/brand/` + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify()
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: FETCH_BRANDS_INIT_ACTION });
      yield toast.success("Deleted successfully", {
        autoClose: 3000
      });
      const resJSON = yield res.json();
      yield put({
        type: DELETE_BRAND_SUCCESS_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: DELETE_BRAND_FAIL_ACTION, error: err });
    } else {
    }
  }
}
function* fetchBrandInActive(data) {
  //console.log("data++++",data)


  let datas = data.value&&data.value.item&&data.value.item.disabled===true?{disabled:false}:{disabled:true}
  //console.log("daatttt",datas)

  const id = data.value&&data.value.item&&data.value.item.id;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/itemMaster/updateDisabled/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(datas)
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_ITEMBRANDINACTIVE_SUCCESS_ACTION,
        payload: resJSON
      });

      yield toast.success("Status changed successfully", {
        autoClose: 3000
      });

      yield put({
        type: FETCH_BRANDS_INIT_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
     yield put({ type: FETCH_ITEMBRANDINACTIVE_FAIL_ACTION, error: err });
  } else {
  }
   }
}

export function* brandActionWatcher() {
  yield takeEvery(FETCH_BRANDS_INIT_ACTION, fetchBrands);
  yield takeEvery(ADD_BRAND_INIT_ACTION, AddBrand);
  yield takeEvery(EDIT_BRAND_INIT_ACTION, EditBrand);
  yield takeEvery(DELETE_BRAND_INIT_ACTION, DeleteItem);
  yield takeEvery(FETCH_ITEMBRANDINACTIVE_INIT_ACTION,fetchBrandInActive);

}
